var _circle, _rect, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIpList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 3.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2743_3096",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2743_3096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4583 23.3333H20.625V18.6667H19.4583V23.3333ZM22.375 23.3333H23.5417V18.6667H22.375V23.3333ZM7.5 10.5H21.5V8.16667H7.5V10.5ZM21.5 26.8333C19.8861 26.8333 18.5104 26.2646 17.3729 25.1271C16.2354 23.9896 15.6667 22.6139 15.6667 21C15.6667 19.3861 16.2354 18.0104 17.3729 16.8729C18.5104 15.7354 19.8861 15.1667 21.5 15.1667C23.1139 15.1667 24.4896 15.7354 25.6271 16.8729C26.7646 18.0104 27.3333 19.3861 27.3333 21C27.3333 22.6139 26.7646 23.9896 25.6271 25.1271C24.4896 26.2646 23.1139 26.8333 21.5 26.8333ZM4 25.6667V5.83333C4 5.19167 4.22847 4.64236 4.68542 4.18542C5.14236 3.72847 5.69167 3.5 6.33333 3.5H22.6667C23.3083 3.5 23.8576 3.72847 24.3146 4.18542C24.7715 4.64236 25 5.19167 25 5.83333V13.6208C24.6306 13.4458 24.2514 13.3 23.8625 13.1833C23.4736 13.0667 23.075 12.9792 22.6667 12.9208V5.83333H6.33333V22.225H13.4208C13.5181 22.8278 13.6688 23.4014 13.8729 23.9458C14.0771 24.4903 14.3444 25.0056 14.675 25.4917L14.5 25.6667L12.75 23.9167L11 25.6667L9.25 23.9167L7.5 25.6667L5.75 23.9167L4 25.6667ZM7.5 19.8333H13.4208C13.4792 19.425 13.5667 19.0264 13.6833 18.6375C13.8 18.2486 13.9458 17.8694 14.1208 17.5H7.5V19.8333ZM7.5 15.1667H15.7833C16.5222 14.4472 17.3826 13.8785 18.3646 13.4604C19.3465 13.0424 20.3917 12.8333 21.5 12.8333H7.5V15.1667Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 20.2759C24.9999 20.8317 24.8179 21.2577 24.4538 21.5538C24.0897 21.8499 23.5715 21.998 22.8992 21.998H22.3458V23.9896H21.4756V18.6666H23.0084C23.6734 18.6666 24.171 18.8026 24.5011 19.0744C24.8337 19.3463 24.9999 19.7467 24.9999 20.2759ZM22.3458 21.2662H22.8081C23.2548 21.2662 23.5824 21.1885 23.7912 21.0332C23.9999 20.8778 24.1043 20.6351 24.1043 20.305C24.1043 19.9992 24.0108 19.771 23.8239 19.6205C23.637 19.47 23.3458 19.3948 22.9501 19.3948H22.3458V21.2662Z",
    fill: "#04B7B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 23.9896V18.6666H20.0368V23.9896H19.1667Z",
    fill: "#04B7B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpList);
export default __webpack_public_path__ + "static/media/IP_List.3351181ed4c0f0c02fde7dd00dc99e23.svg";
export { ForwardRef as ReactComponent };